import React, { useState } from "react";
import FarmAppLogo from "../assets/logo/FarmAppLogo.png";
import { makeStyles } from "@mui/styles";
import { Box, Typography, Grid, Button } from "@mui/material";
import Copyright from "../components/Copyright";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  root: {
    margin: "auto",
    padding: "20px !important",
    minHeight: "100vh",
  },
  logoStyle: {
    textAlign: "center",
    margin: "auto",
  },
  welcomeText: {
    fontSize: "36px !important",
    fontWeight: 600,
    textAlign: "center",
    color: "#4CAF50",
    marginTop: "40px !important",
  },
  selectTitle: {
    fontWeight: 500,
    fontSize: "16px",
    textAlign: "center",
  },
  selectSubTitle: {
    fontWeight: 400,
    fontSize: "12px",
    textAlign: "center",
    marginTop: "10px",
    height: "70px",
  },
  selectedButton: {
    backgroundColor: "#4CAF50",
    color: "#FFFFFF !important",
    "&:hover": {
      backgroundColor: "#388E3C",
    },
  },
  buttonStyle: {
    backgroundColor: "#FFFFFF !important",
    color: "#3F3D3D",
    border: "1px solid #A5A5A5 !important",
  },
  footer: {
    textAlign: "center",
    marginTop: "40px",
  },
}));

const LanguageChangeScreen = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const languageLabel = [
    { key: "en", label: "English" },
    { key: "hi", label: "हिन्दी" },
    { key: "mr", label: "मराठी" },
    { key: "gu", label: "ગુજરાતી" },
    { key: "ta", label: "தமிழ்" },
    { key: "kn", label: "ಕನ್ನಡ" },
    { key: "pa", label: "ਪੰਜਾਬੀ" },
  ];
  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language.toLowerCase());
    // Store user's explicit language choice and set the boolean flag
    localStorage.setItem("i18nextLng", language.toLowerCase());
    localStorage.setItem("userSelectedLanguage", "true");
  };
  const handleNavigate = () => {
    navigate("/landing");
  };

  return (
    <Box
      classes={classes.root}
      sx={{ padding: "20px", backgroundColor: "#FFFFFF" }}
    >
      <Typography className={classes.welcomeText} sx={{ marginBottom: "10px" }}>
        {t("Welcome")}!
      </Typography>
      <div className={classes.logoStyle}>
        <img
          src={FarmAppLogo}
          style={{ width: "100%", maxWidth: "176px", height: "auto" }}
        />
      </div>
      <Typography className={classes.selectTitle} sx={{ marginTop: "10px" }}>
        {t("Please Select Language")}
      </Typography>
      <Typography className={classes.selectSubTitle}>
        {t("You can always change the language later in profile settings")}
      </Typography>
      <Grid container spacing={1} justifyContent="center">
        {languageLabel.map((language) => (
          <Grid item xs={6} sm={4} md={2} key={language.key}>
            <Button
              variant="contained"
              color="primary"
              className={
                selectedLanguage === language.key
                  ? classes.selectedButton
                  : classes.buttonStyle
              }
              onClick={() => handleLanguageSelect(language.key)}
              fullWidth
            >
              {language.label.toUpperCase()}
            </Button>
          </Grid>
        ))}
      </Grid>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          style={{
            backgroundColor: "#4CAF50",
            color: "#FFFFFF",
            width: "100%",
            opacity: !selectedLanguage ? 0.5 : 1,
          }}
          onClick={handleNavigate}
        >
          {t("Get Started")}
        </Button>
      </div>
      <div className={classes.footer}>
        <Copyright />
      </div>
    </Box>
  );
};

export default LanguageChangeScreen;
